import get from 'lodash/get';
import {
  RUNS_LOADING,
  FETCH_RUNS,
  FETCH_RUN_TASKS,
  CREATE_RUN,
  UPDATE_RUN,
  DELETE_RUN,
} from '../actions/runs';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_RUNS:
      return {
        ...state,
        runs: action.payload,
      };
    case FETCH_RUN_TASKS: {
      const runId = get(action, 'payload.runId');
      const runTasks = get(action, 'payload.runTasks');
      const runs = get(state, 'runs', {});
      const runIndex = runs.findIndex((r) => r._id === runId);

      runs[runIndex].tasks = runTasks;

      return {
        ...state,
        runs,
      };
    }
    case RUNS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case CREATE_RUN:
    case DELETE_RUN:
    case UPDATE_RUN:
    default:
      return state;
  }
}
